import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Main from '../views/Main.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Main,
    meta: {
      title: 'Voice Over Acteur: Jason de Ridder',
    },
  },
  {
    path: '/pricing',
    alias: ['/tarieven'],
    name: 'Tarieven',
    meta: {
      title: 'Tarieven - Voice Over Acteur: Jason de Ridder',
    },
    component: () => import('../views/Pricing.vue'),
  },
  {
    path: '/contact',
    name: 'Contact',
    meta: {
      title: 'Contact opnemen - Voice Over Acteur: Jason de Ridder',
    },
    component: () => import('../views/Contact.vue'),
  },
  {
    path: '/request-voice-over',
    alias: ['/voice-over-aanvragen'],
    name: 'Voice over aanvragen',
    meta: {
      title: 'Voice over aanvragen - Voice Over Acteur: Jason de Ridder',
    },
    component: () => import('../views/RequestVoiceOver.vue'),
  },
  {
    path: '/faq',
    alias: ['/veelgestelde-vragen'],
    name: 'Veelgestelde vragen',
    meta: {
      title: 'Veelgestelde vragen - Voice Over Acteur: Jason de Ridder',
    },
    component: () => import('../views/InProgress.vue'),
  },
  {
    path: '/satisfaction',
    alias: ['/tevredenheid'],
    name: 'Tevredenheid',
    meta: {
      title: 'Tevredenheid - Voice Over Acteur: Jason de Ridder',
    },
    component: () => import('../views/InProgress.vue'),
  },
];

const router = new VueRouter({
  routes,
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route
  // with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles,
  // nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse()
    .find((r) => r.meta && r.meta.title);

  // // Find the nearest route element with meta tags.
  // const nearestWithMeta = to.matched.slice().reverse()
  //   .find(r => r.meta && r.meta.metaTags);
  // const previousNearestWithMeta = from.matched.slice().reverse()
  //   .find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }

  // // Remove any stale meta tags from the document using the key attribute we set below.
  // Array.from(document.querySelectorAll('[data-vue-router-controlled]'))
  //   // @ts-ignore
  //   .map(el => el.parentNode.removeChild(el));
  //
  // // Skip rendering meta tags if there are none.
  // if (!nearestWithMeta) return next();
  //
  // // Turn the meta tag definitions into actual elements in the head.
  // nearestWithMeta.meta.metaTags.map((tagDef: { [x: string]: string; }) => {
  //   const tag = document.createElement('meta');
  //
  //   Object.keys(tagDef).forEach(key => {
  //     tag.setAttribute(key, tagDef[key]);
  //   });
  //
  //   // We use this to track which meta tags we create, so we don't interfere with other ones.
  //   tag.setAttribute('data-vue-router-controlled', '');
  //
  //   return tag;
  // })
  //   // Add the meta tags to the document head.
  //   .forEach((tag: any) => document.head.appendChild(tag));

  next();
});

export default router;
